import { render, staticRenderFns } from "./KitNvrDetails.vue?vue&type=template&id=1030ded8"
import script from "./KitNvrDetails.vue?vue&type=script&lang=ts"
export * from "./KitNvrDetails.vue?vue&type=script&lang=ts"
import style0 from "./KitNvrDetails.vue?vue&type=style&index=0&id=1030ded8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports